export default {"src":"/uk/_next/static/media/pinIcon.a2ab0115.svg","height":70,"width":69,"blurWidth":0,"blurHeight":0};